import {useEffect,useRef} from 'react';

// A same-page history entry lets Android/iOS Back close a sheet before leaving
// Availability. Deferred setup avoids duplicate entries in React StrictMode.
export function useAvailabilityBack(onBack) {
    const callback=useRef(onBack);
    callback.current=onBack;
    useEffect(()=>{
        const url=window.location.href;
        const marker=`availability-${Date.now()}-${Math.random()}`;
        let active=false;
        const push=()=>{
            const previous=window.history.state || {};
            window.history.pushState({...previous,idx:(previous.idx || 0)+1,key:marker,availabilitySheet:marker},'',url);
            active=true;
        };
        const timer=setTimeout(push,0);
        const back=()=>{
            if(!active || window.history.state?.availabilitySheet===marker)return;
            active=false;
            if(callback.current()===false)push();
        };
        window.addEventListener('popstate',back);
        return()=>{
            clearTimeout(timer);
            window.removeEventListener('popstate',back);
            if(active && window.location.href===url && window.history.state?.availabilitySheet===marker)window.history.back();
        };
    },[]);
}
